import React from "react";

import Banner from "../components/Support/Banner";
import WhyChoose from "../components/Support/WhyChoose";
import Assistance from "../components/Home/Assistance";

function Support() {
  return (
    <main className="bg-white overflow-hidden">
      <Banner />
      <WhyChoose />
      <div className="mt-[80px] xl:mt-[160px]">
        <Assistance />
      </div>
    </main>
  );
}

export default Support;
